// src/components/header/banner.jsx
import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCalendarAlt,
} from "react-icons/fa";
import "./navheader.css";
import { sendLeadToSellDo } from "../../services/selldo"; //

export default function Banner({
  bannerImgSrc,
  bannerImages,
  showForm = false,
}) {
  /* ---------- Change 1----------- */
  // Use bannerImages (array) if provided, otherwise fall back to single bannerImgSrc
  const slides =
    bannerImages && bannerImages.length > 0 ? bannerImages : [bannerImgSrc];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return; // no need to auto-slide with only 1 image
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); // change slide every 4 seconds
    return () => clearInterval(interval);
  }, [slides.length]);
  /* ---------- Change 1----------- */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    visitDate: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ NEW: loading state

  useEffect(() => {
    const updateHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updated = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };
    setFormData(updated);
    validateForm(updated);
  };

  const validateForm = (data) => {
    const newErrors = {};
    if (!data.name.trim()) newErrors.name = "Name is required";
    if (!data.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = "Invalid email address";
    }
    if (!data.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(data.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    if (!data.terms)
      newErrors.terms = "You must agree to the Terms & Conditions";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ FIXED: Now uses EmailJS (same as contactForm.jsx), passes all fields
  const handleClick = async () => {
    if (!validateForm(formData)) return;

    setLoading(true);
    try {
      await sendLeadToSellDo({
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        city: formData.city,
        visitDate: formData.visitDate,
        source: "Banner Form",
      });

      setSubmitted(true);
      setShowSuccess(true);
      // ✅ ADD THIS
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-16666240151/lu0cCPPHhMYcEJfJios-",
          value: 1.0,
          currency: "INR",
        });
      }
      alert(
        "Thank you for showing your interest! Our business team will reach you soon.",
      );
      setFormData({
        name: "",
        email: "",
        mobile: "",
        city: "",
        visitDate: "",
        terms: false,
      });
      setTimeout(() => {
        setSubmitted(false);
        setShowSuccess(false);
      }, 5000);
    } catch (err) {
      console.error("Banner form submission error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="banner-section">
      <div className="banner-slider">
        {/* invisible spacer keeps the container's height matched to the image */}
        <img src={slides[0]} alt="" className="banner-img banner-spacer" />

        {slides.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Home banner ${index + 1}`}
            className={`banner-img banner-slide ${index === currentSlide ? "active" : ""}`}
          />
        ))}
      </div>

      {showForm && (
        <div className="banner-form-card">
          {submitted ? (
            <div className="banner-thankyou">
              {showSuccess && (
                <p className="banner-success-text">
                  ✅ Form submitted successfully!
                </p>
              )}
              <p>Thank you for your request! We will get back to you soon.</p>
            </div>
          ) : (
            <>
              <h2 className="banner-form-title">We Are Happy to Help</h2>
              <p className="banner-form-subtitle">
                Fill out the details and enquiry now.
              </p>

              {/* Row 1 — Name + Mobile */}
              <div className="banner-form-grid">
                <div>
                  <div className="banner-input-wrap">
                    <FaUser className="banner-icon" />
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.name && (
                    <div className="banner-error">{errors.name}</div>
                  )}
                </div>
                <div>
                  <div className="banner-input-wrap">
                    <FaPhone className="banner-icon" />
                    <input
                      type="text"
                      name="mobile"
                      placeholder="Mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.mobile && (
                    <div className="banner-error">{errors.mobile}</div>
                  )}
                </div>
              </div>

              {/* Row 2 — Email + City */}
              <div className="banner-form-grid">
                <div>
                  <div className="banner-input-wrap">
                    <FaEnvelope className="banner-icon" />
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.email && (
                    <div className="banner-error">{errors.email}</div>
                  )}
                </div>
                <div>
                  <div className="banner-input-wrap">
                    <FaMapMarkerAlt className="banner-icon" />
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Date picker */}
              <div className="banner-date-section">
                <p className="banner-date-label">
                  When are you planning to visit the site?
                </p>
                <div className="banner-input-wrap">
                  <FaCalendarAlt className="banner-icon" />
                  <input
                    type="date"
                    name="visitDate"
                    value={formData.visitDate}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              {/* Checkbox */}
              <div className="terms-container">
                <label className="terms-label">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={formData.terms}
                    onChange={handleChange}
                  />
                  <span>
                    I authorise Pon Anandham &amp; its representatives to
                    contact me with updates and notifications via
                    Email/SMS/What'sApp/Call. This will override DND/NDNC.
                  </span>
                </label>
                {errors.terms && (
                  <div className="invalid-feedback d-block">{errors.terms}</div>
                )}
              </div>

              {/* Submit */}
              <button
                className="submit-button"
                onClick={handleClick}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Enquiry Now"}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
